import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=58900127&"
import script from "./Notifications.vue?vue&type=script&lang=js&"
export * from "./Notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58900127')) {
      api.createRecord('58900127', component.options)
    } else {
      api.reload('58900127', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=58900127&", function () {
      api.rerender('58900127', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NotificationPlugin/Notifications.vue"
export default component.exports